const updateGalleryImages = (swatch, isDropDown, element) => {
  let swatchId = null;

  if (isDropDown) {
    swatchId = swatch?.dataset?.id || null;
  } else {
    const input = swatch?.closest(".swatch-input__label__wrapper")?.querySelector("input");
    swatchId = input?.dataset?.variantId || null;
  }

  const isQuickModal = swatch.closest("quick-add-modal");
  let template;
  let galleryContainer;

  if (isQuickModal) {
    template = document.getElementById(`gallery-template-${swatchId}--quickview`);
    galleryContainer = document.getElementById("product-gallery-container--quickview");
  } else {
    template = document.getElementById(`gallery-template-${swatchId}`);
    galleryContainer = document.getElementById("product-gallery-container");
  }

  if (template) {
    const currentGallery = galleryContainer.querySelector(".variant-gallery");
    if (currentGallery) currentGallery.remove();

    const newGallery = template.content.cloneNode(true);
    galleryContainer.appendChild(newGallery);

    applyThumbnailSliderEnhancements();
    applyProductMediaEnhancements();
  }
};

document.addEventListener("DOMContentLoaded", function () {
  const mainProduct = document.querySelector(".main-product");
  const mainImage = mainProduct?.querySelector(".product__modal-opener");

  if (mainImage) {
    const observer = new MutationObserver(() => {
      applyGalleryChange();
    });

    observer.observe(mainImage, { childList: true, subtree: true });
  }

  if (mainProduct) {
    applyGalleryChange();
  }
});

const applyGalleryChange = () => {
  const mainProduct = document.querySelector(".main-product");
  const stickyPanel = document.querySelector(".add-to-cart-panel");
  const swatches = mainProduct.querySelectorAll(".swatch");
  const options = mainProduct.querySelectorAll(".custom-option");
  const stickyOptions = stickyPanel?.querySelectorAll(".custom-option");
  const is_bundled = mainProduct?.dataset?.is_bundled?.trim() == "true";
  if (!is_bundled) {
    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        updateGalleryImages(swatch, false, mainProduct);
      });
    });
    options?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        updateGalleryImages(swatch, true, mainProduct);
      });
    });
    stickyOptions?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        updateGalleryImages(swatch, true, mainProduct);
      });
    });
  }
};

const applyQuickViewGalleryChange = (quickViewModal) => {
  const mainProduct = quickViewModal.querySelector(".main-product");
  const swatches = quickViewModal.querySelectorAll(".swatch");
  const options = quickViewModal.querySelectorAll(".custom-option");
  const is_bundled = mainProduct?.dataset?.is_bundled?.trim() == "true";
  if (!is_bundled) {
    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        updateGalleryImages(swatch, false, mainProduct);
      });
    });
    options?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        updateGalleryImages(swatch, true, mainProduct);
      });
    });
  }
};
